// VicTech #710:转真人提示音。不看 Chatwoot 个人「音效提醒」设定、不看分页是否聚焦,一律响。
// 浏览器自动播放限制:页面没有过任何使用者互动(点击/按键/触控)前,四大浏览器都会拒绝有声播放。
// 做法:第一次互动时用同一个 <audio> 元素静音 play→pause 一次「解锁」(Safari 需要),之后背景分页也能响。
// 被拒时回呼 onBlocked(由上层提示「点一下页面以启用提示音」)。
export const SOUND_SRC = '/audio/dashboard/bell.mp3';
const GESTURES = ['pointerdown', 'keydown', 'touchstart'];
const MIN_GAP_MS = 1500; // 同一波(例如轮询一次发现多条)只响一次

export class AlertSound {
  constructor({
    src = SOUND_SRC,
    createAudio = s => new Audio(s),
    target = typeof window !== 'undefined' ? window : null,
    now = () => Date.now(),
    onBlocked = () => {},
  } = {}) {
    this.audio = createAudio(src);
    if (this.audio && 'preload' in this.audio) this.audio.preload = 'auto';
    this.target = target;
    this.now = now;
    this.onBlocked = onBlocked;
    this.unlocked = false;
    this.lastPlayedAt = -Infinity;
    this.attempts = 0; // 真的去叫 audio.play() 的次数(诊断用)
    this.plays = 0; // play() 成功 resolve 的次数
    this.unlock = this.unlock.bind(this);
  }

  start() {
    if (!this.target) return;
    GESTURES.forEach(ev =>
      this.target.addEventListener(ev, this.unlock, {
        capture: true,
        passive: true,
      })
    );
  }

  stop() {
    if (!this.target) return;
    GESTURES.forEach(ev =>
      this.target.removeEventListener(ev, this.unlock, { capture: true })
    );
  }

  async unlock() {
    if (this.unlocked || !this.audio) return;
    try {
      this.audio.muted = true;
      await this.audio.play();
      this.audio.pause();
      this.audio.currentTime = 0;
      this.unlocked = true;
      this.stop();
    } catch (e) {
      // 还不行就等下一次互动
    } finally {
      this.audio.muted = false;
    }
  }

  async play() {
    const t = this.now();
    if (t - this.lastPlayedAt < MIN_GAP_MS || !this.audio) return false;
    this.lastPlayedAt = t;
    this.attempts += 1;
    try {
      this.audio.muted = false;
      this.audio.currentTime = 0;
      await this.audio.play();
      this.plays += 1;
      return true;
    } catch (e) {
      if (e && e.name === 'NotAllowedError') this.onBlocked();
      return false;
    }
  }
}
